import React, { FunctionComponent, SVGProps } from 'react';
import { Dropdown } from 'react-bootstrap';
import Dots from '@/assets/img/dots-3.svg';
import './ActionMenu.scss';
import VerticalDots from '@/assets/img/dots-horizontal.svg';

export type ActionMenu = {
  label: string;
  icon?: FunctionComponent<SVGProps<SVGSVGElement>>;
  onClickHandler: (params: any) => any;
  itemClassName: string;
  hide?: boolean;
};

type ActionMenuProps = {
  options: ActionMenu[];
  isDropdown?: boolean;
  isVerticalIcon?: boolean;
};

export const ActionMenu = ({ options, isDropdown = true, isVerticalIcon }: ActionMenuProps) => {
  return (
    <span className="action-menu-wrapper" onClick={(e) => e.stopPropagation()}>
      {isDropdown ? (
        <Dropdown className={`action-menu dot-3-btn ${isVerticalIcon ? 'is-vertical-icon' : ''}`}>
          <Dropdown.Toggle id="dropdown-basic" className="dots-3-icon">
            <img src={isVerticalIcon ? VerticalDots : Dots} className="dots-icon" />
          </Dropdown.Toggle>
          <Dropdown.Menu className="drop-down-backdrop">
            {options?.map(
              (option: any) =>
                !option.hide && (
                  <Dropdown.Item className={option.itemClassName} onClick={option.onClickHandler}>
                    {option.icon && <option.icon />}
                    {option.label}
                  </Dropdown.Item>
                )
            )}
          </Dropdown.Menu>
        </Dropdown>
      ) : (
        <div className="action-no-dropdown">
          {options?.map(
            (option: any) =>
              !option.hide && (
                <Dropdown.Item className={option.itemClassName} onClick={option.onClickHandler}>
                  <option.icon />
                  {option.label}
                </Dropdown.Item>
              )
          )}
        </div>
      )}
    </span>
  );
};

ActionMenu.displayName = 'ActionMenu';
